import { render } from "./image-icon.vue?vue&type=template&id=3c9730a4&ts=true"
import script from "./image-icon.vue?vue&type=script&lang=ts"
export * from "./image-icon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__